export default function PointGuide() {
  const pointTypes = [
    {
      name: 'Vポイント',
      cards: ['三井住友カード（NL）'],
      exchanges: [
        { name: 'キャッシュバック', rate: '1ポイント=1円' },
        { name: 'Amazonギフト券', rate: '1ポイント=1円' },
        { name: 'ANAマイル', rate: '1ポイント=0.6マイル' },
        { name: 'ECモール系ポイント', rate: '1ポイント=0.8ポイント' }
      ],
      tips: 'キャッシュバックが最もお得。カード利用代金に充当できます。'
    },
    {
      name: 'ECモール系ポイント',
      cards: ['大手ECモール系カード'],
      exchanges: [
        { name: 'ECモールでの利用', rate: '1ポイント=1円' },
        { name: 'ペイでの利用', rate: '1ポイント=1円' },
        { name: 'ANAマイル', rate: '2ポイント=1マイル' },
        { name: 'Edyチャージ', rate: '1ポイント=1円' }
      ],
      tips: '経済圏での利用が最もお得。期間限定ポイントは早めに使いましょう。'
    },
    {
      name: 'リクルートポイント',
      cards: ['リクルートカード'],
      exchanges: [
        { name: 'Pontaポイント', rate: '1ポイント=1ポイント' },
        { name: 'じゃらんでの利用', rate: '1ポイント=1円' },
        { name: 'ホットペッパーでの利用', rate: '1ポイント=1円' },
        { name: 'ローソンでの利用', rate: '1ポイント=1円（Ponta経由）' }
      ],
      tips: 'Pontaポイントに交換すれば、ローソンやガソリンスタンドでも使えます。'
    },
    {
      name: 'カード会社ポイント',
      cards: ['国際ブランド系カード W'],
      exchanges: [
        { name: 'Amazonでの利用', rate: '1ポイント=3.5円' },
        { name: 'スターバックスカード', rate: '1ポイント=4円' },
        { name: 'nanacoポイント', rate: '1ポイント=5ポイント' },
        { name: 'ANAマイル', rate: '1ポイント=3マイル' }
      ],
      tips: 'Amazonやスターバックスカードへの交換が高レート。'
    },
    {
      name: 'dポイント',
      cards: ['dカード'],
      exchanges: [
        { name: 'd払いでの利用', rate: '1ポイント=1円' },
        { name: 'ローソンでの利用', rate: '1ポイント=1円' },
        { name: 'マクドナルドでの利用', rate: '1ポイント=1円' },
        { name: 'JALマイル', rate: '1ポイント=0.5マイル' }
      ],
      tips: 'd払い加盟店が多く、使い道が豊富。期間限定ポイントに注意。'
    }
  ];

  const usageTips = [
    {
      icon: 'ri-exchange-line',
      title: 'ポイント交換レートを確認',
      description: '交換先によってレートが異なります。最もお得な交換先を選びましょう。'
    },
    {
      icon: 'ri-time-line',
      title: '有効期限をチェック',
      description: 'ポイントには有効期限があります。期間限定ポイントは特に注意が必要です。'
    },
    {
      icon: 'ri-shopping-bag-3-line',
      title: '日常の買い物で使う',
      description: 'コンビニやスーパーなど、日常的に使えるお店で消費するのが効率的です。'
    },
    {
      icon: 'ri-gift-line',
      title: 'ギフト券に交換',
      description: 'Amazonギフト券などに交換すれば、幅広い商品に使えます。'
    },
    {
      icon: 'ri-flight-takeoff-line',
      title: 'マイルに交換',
      description: '旅行好きなら、航空会社のマイルに交換するのもおすすめです。'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'キャッシュバック',
      description: 'カード利用代金に充当できるキャッシュバックが最もシンプルでお得です。'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <h3 className="text-3xl font-bold text-center mb-4 text-[#003366]">
          ポイント交換先・活用術ガイド
        </h3>
        <p className="text-center text-gray-600 mb-12">
          貯めたポイントを最大限に活用する方法をご紹介します
        </p>

        {/* ポイント種類別交換先 */}
        <div className="space-y-6 mb-16">
          {pointTypes.map((point, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 shadow-lg"
            >
              <div className="flex flex-col md:flex-row gap-6">
                <div className="md:w-1/3">
                  <h4 className="text-xl font-bold text-[#003366] mb-2">{point.name}</h4>
                  <div className="text-sm text-gray-600 mb-3">
                    対象カード：{point.cards.join('、')}
                  </div>
                  <div className="bg-yellow-50 border-l-4 border-[#FFB800] p-3 rounded">
                    <div className="flex items-start gap-2">
                      <i className="ri-lightbulb-line text-[#FFB800] text-lg flex-shrink-0 w-5 h-5 flex items-center justify-center"></i>
                      <p className="text-sm text-gray-700">{point.tips}</p>
                    </div>
                  </div>
                </div>

                <div className="md:w-2/3">
                  <div className="text-sm font-bold text-gray-700 mb-3">主な交換先</div>
                  <div className="grid sm:grid-cols-2 gap-3">
                    {point.exchanges.map((exchange, idx) => (
                      <div
                        key={idx}
                        className="bg-gray-50 rounded-lg p-3 border border-gray-200"
                      >
                        <div className="font-bold text-[#003366] mb-1">{exchange.name}</div>
                        <div className="text-sm text-[#FFB800] font-bold">{exchange.rate}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* ポイント活用のコツ */}
        <div className="mb-12">
          <h4 className="text-2xl font-bold text-center mb-8 text-[#003366]">
            ポイントを賢く使う6つのコツ
          </h4>
          <div className="grid md:grid-cols-3 gap-6">
            {usageTips.map((tip, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 text-center hover:shadow-xl transition-all"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-[#FFB800] to-[#FFA000] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${tip.icon} text-white text-2xl w-8 h-8 flex items-center justify-center`}></i>
                </div>
                <h5 className="text-lg font-bold text-[#003366] mb-3">{tip.title}</h5>
                <p className="text-sm text-gray-700">{tip.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* ポイント最大化のコツ */}
        <div className="bg-gradient-to-r from-[#003366] to-[#004488] rounded-xl p-8 text-white">
          <h4 className="text-2xl font-bold mb-6 text-center">
            ポイント還元を最大化する3つの秘訣
          </h4>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="text-4xl font-bold text-[#FFB800] mb-3">1</div>
              <h5 className="text-lg font-bold mb-2">特約店を活用</h5>
              <p className="text-sm">
                コンビニ、ネット通販など、よく使うお店で高還元率のカードを選ぶ
              </p>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-[#FFB800] mb-3">2</div>
              <h5 className="text-lg font-bold mb-2">固定費を集約</h5>
              <p className="text-sm">
                携帯料金、光熱費など毎月の固定費を高還元カードに集約する
              </p>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-[#FFB800] mb-3">3</div>
              <h5 className="text-lg font-bold mb-2">複数カード使い分け</h5>
              <p className="text-sm">
                シーンに応じて2〜3枚のカードを使い分けて還元率を最大化
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
